import { memo } from 'react';
import { useTranslation } from 'next-i18next';

import { IconButton, IconName } from 'components';

import styles from './TopTitleBar.module.scss';

interface TopTitleBarProps {
  title: string;
  isInfoComplete: boolean;
  iconName: IconName;
  onIconClick: () => void;
}

export const TopTitleBar = memo(
  ({ title, isInfoComplete, iconName, onIconClick }: TopTitleBarProps) => {
    const [t] = useTranslation('candidate.profile');
    return (
      <section className={styles.container}>
        <div className={styles.content}>
          <div className={styles.left}>
            <p className={styles.title}>{title}</p>
            {!isInfoComplete && (
              <p className={styles.warning}>
                {t('top-title-bar.not-completed')}
              </p>
            )}
          </div>
          <IconButton
            onClick={onIconClick}
            iconName={iconName}
            size="xsmallplus"
            className={styles.icon}
          />
        </div>
      </section>
    );
  }
);

TopTitleBar.displayName = 'TopTitleBar';
